<template>
  <div class="published-container">
    <header>
      <span class="title">已发布应用</span>
      <div class="right">
        <el-input class="seach" size="small" v-model="searchInput" placeholder="名称/上传人" suffix-icon="el-icon-search" @keyup.enter.native="search"></el-input>
        <el-button :disabled="disabled" @click="applyManage(3)" v-if="funAuth.includes(31)">删  除</el-button>
        <el-button type="primary" :disabled="disabled" @click="applyManage(2)" v-if="funAuth.includes(29)">编 辑</el-button>
        <el-button type="primary" :disabled="disabled" @click="applyManage(1)" v-if="funAuth.includes(30)">设为精品应用</el-button>
        <el-button type="primary" :disabled="disabled" @click="applyManage(0)" v-if="funAuth.includes(28)">管理下载次数</el-button>
        <el-button type="primary" :disabled="disabled" @click="versionSetting">可安装版本设置</el-button>
      </div>
    </header>
    <el-table ref='multipleTable' :data='tableList' tooltip-effect='dark' style='width: 100%'  @row-click="audit" @selection-change='handleSelectionChange' class="el-table-01">
      <el-table-column type='selection' width='55'></el-table-column>
      <el-table-column label='名称'>
          <template  slot-scope='scope'>
            <span class="ellipsis" :style="ellipsisStyle">{{scope.row.template_name}}</span>
          </template>
      </el-table-column>
      <el-table-column prop='version' label='版本号'></el-table-column>
      <el-table-column  label='介绍'>
        <template  slot-scope='scope'>
            <span class="ellipsis" :style="ellipsisStyle">{{scope.row.introduce}}</span>
        </template>
      </el-table-column>
      <el-table-column prop='fit_industry' label='应用类型'>
        <template  slot-scope='scope'>
          <span class="ellipsis" :style="ellipsisStyle" v-text="classifyInfo(scope.row.classifyInfo, 1)"></span>
        </template>
      </el-table-column>
      <el-table-column prop='func_type' label='所属行业'>
        <template  slot-scope='scope'>
          <span class="ellipsis" :style="ellipsisStyle" v-text="classifyInfo(scope.row.classifyInfo, 2)"></span>
        </template>
      </el-table-column>
      <el-table-column prop='charge_type' label='类型'>
        <template  slot-scope='scope'>
            <span v-text="scope.row.charge_type === '0' ? '免费':'付费'"></span>
        </template>
      </el-table-column>
      <el-table-column prop='download_number' label='安装次数'></el-table-column>
      <el-table-column prop='upload_user' label='开发者'></el-table-column>
      <el-table-column prop='user_name' label='审核人'></el-table-column>
    </el-table>
    <el-pagination @size-change='handleSizeChange' @current-change='handleCurrentChange' :current-page='pageNum' :page-sizes='[10, 20, 50, 100]' :page-size='pageSize' layout='total, sizes, prev, pager, next, jumper' :total='tableTotal'></el-pagination>

    <el-dialog title="管理下载次数" :visible.sync="dialogDownloads" class="dialog-manage">
      <span class="title">下载次数</span>
      <div class="right">
        <el-input v-model="inputNum" placeholder="请输入" size="medium" type="number"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogDownloads = false">取 消</el-button>
        <el-button type="primary" @click="downloads">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="设为精品应用" :visible.sync="dialogQuality" class="dialog-manage">
      <span class="title">序号</span>
      <div class="right">
        <el-input v-model="inputNum" placeholder="请输入" size="medium" type="number"></el-input>
        <div class="note">序号越小，前台显示越靠前</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogQuality = false">取 消</el-button>
        <el-button type="primary" @click="quality">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="dialogDelete" class="prompt-box">
      <i class="iconfont icon-prompt-box"></i>
      <div class="content">删除</div>
      <div class="note">该应用为已发布状态，删除后应用将在应用中心同步被删除，用户将无法继续在安装此应用。</div>
      <div class="prompt">你确定要删除吗？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogDelete = false">取 消</el-button>
        <el-button type="primary" @click="applyDelete">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="可安装版本设置" :visible.sync="versionSetDialog" class="version-setting">
      <p class="hintContent">请设置哪些客户的版本可以安装此应用，功能版本和组件皆符合才可以安装。</p>
      <p class="title">哪些客户可安装此应用，功能版本为以下版本即可（多选）：</p>
      <p>
        <el-select multiple collapse-tags v-model="version" placeholder="请选择(必填)" size="medium">
          <el-option v-for="item in vOptions" :key="item.id" :label="item.version_name" :value="item.id"></el-option>
        </el-select>
      </p>
      <p class="title">哪些客户可安装此应用，组件版本为以下版本即可（多选）：</p>
      <p>
          <el-select multiple collapse-tags v-model="field_typesId" placeholder="请选择(必填)" size="medium">
            <el-option v-for="item in componentData" :key="item.id" :label="item.cm_name" :value="item.id"></el-option>
          </el-select>
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="versionSetDialog = false">取 消</el-button>
        <el-button type="primary" @click="versionSet">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {HTTPServer} from '@/common/js/ajax.js'
import mixin from '@/common/js/mixins.js'
import {appIndustry, regular} from '@/common/js/constant.js'
export default {
  data () {
    return {
      defaultMsg: '<b>已发布应用</b>',
      ellipsisStyle: '-webkit-line-clamp: 5;-webkit-box-orient: vertical;',
      classification: {}, // 业务分类
      industry: {}, // 行业分类
      funAuth: [],
      searchInput: '',
      tableList: [],
      disabled: true,
      pageSize: 20,
      pageNum: 1,
      tableTotal: 0,
      dialogDownloads: false,
      inputNum: '',
      dialogQuality: false,
      dialogDelete: false,
      versionSetDialog: false,
      vOptions: [],
      version: [], // 功能版本
      componentData: [],
      field_typesId: [] // 组件版本
    }
  },
  mixins: [mixin],
  mounted () {
    this.searchValue = ''
    this.queryFchBtnAuth(({moduleId: 8}))
    this.queryReleaseApplicationList()
  },
  methods: {
    /** 获取注册客户 */
    queryReleaseApplicationList () {
      var jsondata = {'pageNum': this.pageNum, 'pageSize': this.pageSize, 'keyWord': this.searchValue}
      HTTPServer.queryReleaseApplicationList(jsondata, 'Loading').then((res) => {
        this.tableList = res.dataList
        var pageInfo = res.pageInfo
        this.tableTotal = pageInfo.totalRows
      })
    },
    /** 搜索 */
    search () {
      this.searchValue = JSON.parse(JSON.stringify(this.searchInput))
      this.pageNum = 1
      this.pageSize = 20
      this.queryReleaseApplicationList()
    },
    /** 列表选择 */
    handleSelectionChange (val) {
      this.multipleSelection = val
      this.disabled = (this.multipleSelection.length === 0)
    },
    /** 显示每页条数 */
    handleSizeChange (val) {
      this.pageSize = val
      this.pageNum = 1
      this.queryReleaseApplicationList()
    },
    /** 跳转第几页 */
    handleCurrentChange (val) {
      this.pageNum = val
      this.queryReleaseApplicationList()
    },
    // 行的点击事件
    audit (val) {
      console.log(val)
      this.$router.push({name: 'ApplyDetail', query: {'id': val.id}, params: {detail: 1}})
    },
    applyManage (type) {
      if (this.multipleSelection.length > 1 && type !== 3) {
        this.$message.error('只能选择一条数据')
        return
      }
      if (type === 0) { // 管理下载次数
        this.dialogDownloads = true
        this.inputNum = ''
      } else if (type === 1) { // 设为精品应用
        this.dialogQuality = true
        this.inputNum = ''
      } else if (type === 2) { // 编 辑
        this.$router.push({name: 'ApplyDetail', query: {'id': this.multipleSelection[0].id}, params: {detail: 2}})
      } else if (type === 3) { // 删  除
        this.dialogDelete = true
      }
    },
    /** 确认次数 */
    downloads () {
      if (!this.inputNum) {
        this.$message({
          showClose: true,
          message: '下载次数不能为空',
          type: 'error'
        })
        return
      }
      if (!regular.positiveInteger.test(this.inputNum)) {
        this.$message.error('序号格式错误')
        return
      }
      var jsondata = {'id': this.multipleSelection[0].id, 'download_number': this.inputNum}
      HTTPServer.editApplicationNumber(jsondata, 'Loading').then((res) => {
        this.$message({
          showClose: true,
          message: '操作成功！',
          type: 'success'
        })
        this.queryReleaseApplicationList()
        this.dialogDownloads = false
      })
    },
    /** 设为精品 */
    quality () {
      if (!this.inputNum) {
        this.$message({
          showClose: true,
          message: '序号不能为空',
          type: 'error'
        })
        return
      }
      if (!regular.positiveInteger.test(this.inputNum)) {
        this.$message.error('序号格式错误')
        return
      }
      var jsondata = {'id': this.multipleSelection[0].id, 'order': this.inputNum}
      HTTPServer.editNonsuchApplication(jsondata, 'Loading').then((res) => {
        this.$message({
          showClose: true,
          message: '操作成功！',
          type: 'success'
        })
        this.queryReleaseApplicationList()
        this.dialogQuality = false
      })
    },
    /** 删除 */
    applyDelete () {
      var id = []
      for (var i = 0; i < this.multipleSelection.length; i++) {
        id.push(this.multipleSelection[i].id)
      }
      var jsondata = {'id': id.toString()}
      HTTPServer.deleteApplication(jsondata, 'Loading').then((res) => {
        this.$message({
          showClose: true,
          message: '操作成功！',
          type: 'success'
        })
        this.queryReleaseApplicationList()
        this.dialogDelete = false
      })
    },
    fitInit (id) {
      let str
      appIndustry.industry.map((item) => {
        if (item.id === id) {
          str = item.label
        }
      })
      return str
    },
    funInit (id) {
      let str
      appIndustry.classification.map((item) => {
        if (item.id === id) {
          str = item.label
        }
      })
      return str
    },
    versionSetting () {
      // if (this.multipleSelection.length > 1) {
      //   this.$message({
      //     showClose: true,
      //     message: '每次仅可对一个应用进行设置，不支持批量',
      //     type: 'error'
      //   })
      //   return
      // }
      this.version = []
      this.field_typesId = []
      if (this.multipleSelection.length === 1) {
        let data = JSON.parse(JSON.stringify(this.multipleSelection[0]))
        if (data.fc_id) {
          data.fc_id.split(',').map(item => {
            this.version.push(parseInt(item))
          })
        }
        if (data.cm_id) {
          data.cm_id.split(',').map(item => {
            this.field_typesId.push(parseInt(item))
          })
        }
      }
      this.versionSetDialog = true
      this.queryAllChargingStrategy()
      this.getEnableComponentManageList()
    },
    /** 获取 组件管理 */
    getEnableComponentManageList (id) {
      HTTPServer.getEnableComponentManageList({}, 'Loading').then((res) => {
        this.componentData = res
      })
    },
    versionSet () {
      if (this.version.length === 0) {
        this.$message({
          showClose: true,
          message: '功能版本不能为空!',
          type: 'error'
        })
        return
      }
      if (this.field_typesId.length === 0) {
        this.$message({
          showClose: true,
          message: '组件版本不能为空!',
          type: 'error'
        })
        return
      }
      let ids = []
      this.multipleSelection.map(v => {
        ids.push(v.id)
      })
      let jsondata = {'id': ids.toString(), 'fc_id': this.version.toString(), 'cm_id': this.field_typesId.toString()}
      console.log(jsondata)
      HTTPServer.updateApplicationVersion(jsondata, 'Loading').then((res) => {
        this.componentData = res
        this.queryReleaseApplicationList()
        this.versionSetDialog = false
      })
    },
    classifyInfo (arr, type) {
      var text = []
      arr.map(v => {
        if (v.classify_type === type) {
          text.push(this.languageFilter(v.classify_name))
        }
      })
      console.log(text)
      return text.toString()
    },
    // 语言过滤
    languageFilter (name) {
      if (JSON.stringify(name).includes('{\\"language\\"')) {
        if (typeof name === 'string') {
          return JSON.parse(name).language.zh
        } else {
          return name.language.zh
        }
      } else {
        return name
      }
    }
  }
}
</script>

<style lang="scss">
.published-container{
  .dialog-manage{
    .el-dialog{
      width: 500px;
    }
    .el-dialog__header{
      padding: 13px 20px;
      box-shadow: inset 0 -1px 0 0 #E5E5E5;
    }
    .el-dialog__headerbtn{
      top: 14px;
      .el-dialog__close{
        font-size: 24px;
      }
    }
    .el-dialog__body{
      padding: 30px 20px 28px;
      min-height: 120px;
      .title{
        float: left;
        width: 80px;
        text-align: right;
        padding-right: 14px;
        line-height: 36px;
        font-size: 14px;
        color: #666;
      }
      .right{
        width: calc(100% - 100px);
        display: inline-block;
      }
      .note{
        font-size: 12px;
        color: #FF1717;
        margin-top: 10px;
      }
    }
    .el-dialog__footer{
      padding: 10px 20px;
      box-shadow: inset 0 1px 0 0 #E5E5E5;
      .el-button{
        padding: 8px 16px;
      }
    }
  }
  .version-setting{
    .el-dialog{
      width: 600px;
    }
    .el-dialog__header{
      padding: 13px 20px;
      box-shadow: inset 0 -1px 0 0 #E5E5E5;
    }
    .el-dialog__body{
      padding: 20px 30px;
      p{
        line-height: 40px;
      }
      .hintContent{

      }
      .el-select{
        width: 88%;
      }
    }
    .el-dialog__footer{
      padding: 10px 20px;
      box-shadow: inset 0 1px 0 0 #E5E5E5;
      .el-button{
        padding: 8px 16px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/application/published-apply.vue